import { useSyncExternalStore } from 'react'

function subscribe(query: string, onStoreChange: () => void) {
    const mediaQueryList = matchMedia(query)
    mediaQueryList.addEventListener('change', onStoreChange)
    return () => mediaQueryList.removeEventListener('change', onStoreChange)
}

export const useMediaQuery = (query: string) => {
    return useSyncExternalStore(
        onStoreChange => subscribe(query, onStoreChange),
        () => matchMedia(query).matches,
        () => false,
    )
}
